import React from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';
import Detail from './Detail';
import Dialog from '../dialogs/Dialog';
import { parseValue, getValueByPath, getPrimaryField, processBefore, processAfter, processEnumsAfter, isDateType } from '../utils/helper';
import { showMsg } from '../utils/logger';
import withMeta from '../utils/withMeta';

import flags from '../utils/flags';
import "./Dialog.scss";

import { connect } from 'react-redux';

const DEFAULT_STATE = {
  isLoading: false,
  data: [],
  total: 0,
  isDetailLoading: false,
  isDetailDisabled: false,
  detailData: {},
  modified: false,
  selected: [],
  printItems: [],
  cellRender: null,
  rowProps: null,
  subGridDetailRow: null
};


let buttonClicked = null;
class DialogComponent extends React.Component {
  detailData;

  constructor(props) {
    super(props);

    this.state = {
      detailSchema: [],
      ui: null,
      agrs: null,
      pages: null,
      akc: {
        hidden: 0,
        disabled: 0,
        akc: []
      },
      primaryField: props.primaryField,
      level: props.level || 0,
      [props.primaryField]: DEFAULT_STATE,
      fullscreen: props.fullscreen
    }
  }

  setStateAsync = (fnc) => {
    return new Promise((resolve) => {
      this.setState(fnc, resolve);
    });
  }

  getReducerState = async (action, data, state) => {
    const { reducer } = this.props;
    if (!reducer) { return state }
    const reducerState = await reducer(action, { ...data, obj: this.getObj() }, { ...state, primaryField: this.props.primaryField }, this.state);
    return reducerState;
  }

  processReducer = async (action, data) => {
    const state = await this.getReducerState(action, data, _.cloneDeep(this.state));
    await this.setStateAsync(s => (state));
  }

  handleChange = (filter, sort, page) => {
    this.filter = filter;
    this.sort = sort;
    this.page = page;
  }

  copyFilter = (filter) => {
    return {
      ...filter,
      filters: filter.filters.map(x => {
        if (x.value instanceof Date) {
          return {
            ...x,
            value: new Date(x.value.getTime())
          }
        }

        return x;
      })
    };
  }

  processEnumsDetail = (data) => {
    this.detailEnumColumns.forEach(column => {
      if (typeof (data[column.field]) !== 'object') {
        const value = this.state[column.dataField].data.find(el => el[column.primaryField] === _.get(data, column.field) || el[column.primaryField] === _.get(data, column.field + "." + column.primaryField)) || null
        _.set(data, column.field, value);

      }
    })
  }

  getList = async (filter, sort, page, primaryField) => {
    const { filterFactory } = this.props;

    const f = filterFactory ? filterFactory(primaryField, this.copyFilter(filter)) : this.copyFilter(filter);
    try {
      await this.setStateAsync(s => ({ [primaryField]: { ...this.state[primaryField], isLoading: true, data: [], total: 0 } }));
      const res = await this.props.meta.getList(primaryField, f, sort, page, this.props.db);
      if (this.gridDateColumns.length > 0) {
        res.Data.Items.map(x => {
          x = processAfter(this.state.detailSchema, x);
          return x;
        })
      }

      const state = { [primaryField]: { ...this.state[primaryField], isLoading: false, data: res.Data.Items, total: res.Data.TotalRecords } };
      const reducerState = await this.getReducerState('GET_LIST', {}, state);
      await this.setStateAsync(s => (reducerState));
      this.props.getListSuccess(res);
    }
    catch (error) {
      this.setState(state => ({ [primaryField]: { ...state[primaryField], isLoading: false, data: [], total: 0 } }));
      this.props.getListFailure(error);
    }
    this.getTotal(f, primaryField);
  }

  getTotal = async (filter, primaryField) => {
    try {
      const res = await this.props.meta.getTotal(primaryField, filter, this.props.db);
      if (res?.Data?.TotalRecords) {
        const state = { [primaryField]: { ...this.state[primaryField], total: res.Data.TotalRecords } };
        const reducerState = await this.getReducerState('GET_TOTAL', {}, state);
        await this.setStateAsync(s => (reducerState));
      }
    }
    catch (error) {
      this.props.getListFailure(error);
    }
  }

  get = async (val) => {
    try {
      await this.setStateAsync(s => ({ [this.props.primaryField]: { ...this.state[this.props.primaryField], isDetailLoading: true } }));

      let res = this.state.allColumns ? (typeof (val) == 'object' ? val : { Data: this.state[this.props.primaryField].data.find(x => x[getPrimaryField(this.props.primaryField)] === val) }) : await this.props.meta.get(this.props.primaryField, val, this.props.db);
      if (!res?.Data) {
        res = { Data: this.detailData }
      }
      else {
        res.Data = processAfter(this.state.detailSchema, res.Data || {});
      }
      this.processEnumsDetail(res.Data);

      const state = { [this.props.primaryField]: { ...this.state[this.props.primaryField], modified: false, isDetailLoading: false, isDetailDisabled: false, detailData: res.Data } };
      let reducerState = await this.getReducerState('GET', {}, state);
      if (res.Data[getPrimaryField(this.props.primaryField)] === null) {
        reducerState = await this.getReducerState('GET_CREATE', {}, reducerState);
      }
      await this.setStateAsync(s => (reducerState));
      await this.props.getDetailSuccess(res);
    }
    catch (error) {
      this.setState(state => ({ [this.props.primaryField]: { ...state[this.props.primaryField], modified: false, isDetailLoading: false, isDetailDisabled: false, listDetail: {} } }));
      this.props.getDetailFailure(error);
    }
  }

  _get = async (primaryField, id) => {
    try {
      let res = await this.props.meta.get(primaryField, id, this.props.db);
      const schema = await this.props.meta.getSchema(primaryField, this.props.db);
      if (res?.Data && res.Data !== null) {
        res.Data = processAfter(schema?.Detail, res.Data);
        res.Data = processEnumsAfter(schema?.Detail, res.Data);
        return res.Data;
      }
      else {
        return null;
      }
    }
    catch (error) {
      return null;
    }
  }

  create = async (d) => {
    if (this.state.akc.hidden & flags.ADD) { return; }

    const detailData = processBefore(this.state.detailSchema, d);
    detailData[getPrimaryField(this.props.primaryField)] = 0;

    try {
      this.setState(state => ({ [this.props.primaryField]: { ...state[this.props.primaryField], isDetailLoading: true, isDetailDisabled: true } }));
      const res = await this.props.meta.create(this.props.primaryField, detailData, this.props.db);
      res.Data = processAfter(this.state.detailSchema, res.Data);
      this.processEnumsDetail(res.Data);

      const state = { [this.props.primaryField]: { ...this.state[this.props.primaryField], modified: false, isDetailLoading: false, isDetailDisabled: false, detailData: res.Data } };
      const reducerState = await this.getReducerState('CREATE', { data: res.Data }, state);
      await this.setStateAsync(s => (reducerState));
      this.props.createSuccess(res);
      return res.Data[getPrimaryField(this.props.primaryField)];
    }
    catch (error) {
      const state = { [this.props.primaryField]: { ...this.state[this.props.primaryField], modified: false, isDetailLoading: false, isDetailDisabled: false, listDetail: {} } };
      await this.setStateAsync(s => (state));
      this.props.createFailure(error);
    }
  }

  update = async (id, d) => {
    if (id === 0) {
      return await this.create(d);
    }
    if (this.state.akc.hidden & flags.EDIT) { return; }

    const detailData = processBefore(this.state.detailSchema, d);
    const primaryField = getPrimaryField(this.props.primaryField);

    try {
      this.setState(state => ({ [this.props.primaryField]: { ...state[this.props.primaryField], isDetailLoading: true, isDetailDisabled: true } }));
      const res = await this.props.meta.update(this.props.primaryField, id, detailData, this.props.db);
      res.Data = processAfter(this.state.detailSchema, res.Data);
      this.processEnumsDetail(res.Data);

      const data = this.state[this.props.primaryField].data.map(item => item[primaryField] === res.Data[primaryField] ? { ...item, ...res.Data } : item);

      const state = { [this.props.primaryField]: { ...this.state[this.props.primaryField], modified: false, isDetailLoading: false, isDetailDisabled: false, detailData: res.Data, data: data, oldData: null } };
      const reducerState = await this.getReducerState('UPDATE', { data: res.Data }, state);
      await this.setStateAsync(s => (reducerState));
      //zmena dat pre selected
      if (this.state[primaryField]?.selected.length === 1 && this.state[primaryField]?.selected?.[0]?.[primaryField] === res.Data?.[primaryField]) {
        this.handleSelect([res.Data])
      }
      this.props.updateSuccess(res);
    }
    catch (error) {
      const state = { [this.props.primaryField]: { ...this.state[this.props.primaryField], modified: false, isDetailLoading: false, isDetailDisabled: false, listDetail: {} } };
      await this.setStateAsync(s => (state));
      this.props.updateFailure(error);
    }
  }

  delete = async (id) => {
    if (this.state.akc.hidden & flags.DELETE) { return; }
    try {
      await this.props.meta.delete(this.props.primaryField, id, this.props.db);
      this.props.deleteSuccess();
    }
    catch (error) {
      this.props.deleteFailure(error);
    }
  }

  changeField = async (name, value) => {
    const { primaryField } = this.props;
    const detailData = { ...this.state[primaryField].detailData };
    const oldValue = _.get(detailData, name);
    _.set(detailData, name, value);
    const state = { [primaryField]: { ...this.state[primaryField], modified: true, detailData: detailData } };
    let reducerState = await this.getReducerState('CHANGE', { field: name, value: value, oldValue: oldValue }, state);
    if (getPrimaryField(this.props.primaryField) === name && value === 0 && oldValue !== 0) {
      reducerState = await this.getReducerState('CHANGE_COPY', {}, reducerState);
    }
    await this.setStateAsync(s => (reducerState));
  }

  getPickerValue = async (primaryField, defaultValue) => {
    const id = parseValue(defaultValue, 'container');
    if (id === parseInt(id, 10)) {
      const res = await this.props.meta.get(primaryField, id, this.props.db);
      if (res && res.Data) {
        this.setState({ isDetailLoading: false });
        return res.Data;
      }
    }
    return null;
  }

  getValue = async (x) => {
    const { defaultValue } = x;

    switch (x.type) {
      case "enum":
      case "buttongroup":
      case "radio":
        const id = parseValue(defaultValue, 'enum');
        return defaultValue ? this.state[x.dataField].data?.find(e => e[getPrimaryField(x.primaryField)] === id) : null;
      case 'container':
        return defaultValue ? await this.getPickerValue(x.primaryField, defaultValue) : null;
      case 'boolean':
        return parseValue(defaultValue) || false;
      default:
        return parseValue(defaultValue, x.type);
    }
  }

  getSchema = async () => {
    this.setState({ isDetailLoading: true });
    const emptySort = [];
    const emptyPage = { skip: 0, take: 1000 };
    const emptyFilter = { filters: [] };
    const schema = await this.props.meta.getSchema(this.props.primaryField, this.props.db);
    this.gridDateColumns = schema.Grid.filter(x => isDateType(x.filter));
    this.gridEnumColumns = schema.Grid.filter(x => x.type === 'enum' || x.type === 'buttongroup' || x.type === 'radio');
    this.detailEnumColumns = schema.Detail.filter(x => x.type === 'enum' || x.type === 'buttongroup' || x.type === 'radio');

    this.gridEnumColumns.forEach((x) => {
      x.primaryField = getPrimaryField(x.primaryField);
      x.dataField = `listGrid${x.field}`;
      x.data = `list${x.field}`;
    });
    this.detailEnumColumns.forEach((x) => {
      x.primaryField = getPrimaryField(x.primaryField);
      x.dataField = `list${x.field}`;
    });

    let state = {};
    for (const x of this.gridEnumColumns) {
      if (x.primaryField && x.primaryField !== "I_HOD" && !x.EnumData) {
        const res = await this.props.meta.getList(x.primaryField, emptyFilter, emptySort, emptyPage, this.props.db);
        x.EnumData = res.Data ? res.Data.Items : [];
      }
      let data = (!x.required && x.EnumData) ? [{ [getPrimaryField(x.primaryField)]: null, [x.textField]: "" }, ...x.EnumData] : x.EnumData;
      state = { ...state, [`listGrid${x.field}`]: data, [`list${x.field}`]: { data: data } };
    }
    await this.setStateAsync(s => (state));

    this.detailData = {};
    for (const x of schema.Detail) {
      const defaultValue = await this.getValue(x);
      _.set(this.detailData, x.field, defaultValue);
    }
    const ui = schema?.Args?.ui;
    const args = _.omit(schema?.Args, "ui");
    if (this.props.frmValue) {
      schema.Detail.forEach(x => {
        if (this.props.frmValue[x.field]) {
          x.disabled = true;
        }
      })
      this.detailData = { ...this.detailData, ...this.props.frmValue }
    }

    const akc = await this.props.meta.getAkc(schema.Id, false, this.props.db);
    state = {
      primaryField: this.props.primaryField,
      detailSchema: schema.Detail, akc, ui, args, pages: schema.Pages, [this.props.primaryField]: { ...DEFAULT_STATE, detailData: this.detailData, printItems: [] }
    };
    const reducerState = await this.getReducerState('GET_SCHEMA', {}, state);
    this.setState(reducerState);
    this.setState({ isDetailLoading: false });
  }

  async componentDidMount() {
    if (this.props.primaryField) {
      await this.getSchema();
    }
  }

  async componentDidUpdate(prevProps) {
    if (this.props.primaryField && this.props.primaryField !== prevProps.primaryField) {
      await this.getSchema();
    }
  }

  getJoinValue = (x, selected) => {
    if (!_.isNil(x.Value)) {
      return parseValue(x.Value, x.Type);
    }
    const value = ["isnull", "isnotnull"].includes(x.Operator) ? null : _.uniq(getValueByPath(selected, x.ParentField)).join();

    if (value === "") {
      return x.Operator === "eq-ifexists" ? null : "-1";
    }
    return value;
  }

  getObj = (akc, isDetailAkc = false) => {

    return {
      processReducer: this.processReducer,
      showMsg: this.props.showMsg,

      self: this,
      componentFactory: this.props.componentFactory,
      akc: akc,
      isDetailAkc: isDetailAkc
    }
  }

  handleConfirm = () => {
    buttonClicked = "confirm";
    this.handleDetailSaveClick();
  }

  handleMiddle = () => {
    buttonClicked = "middle";
    this.handleDetailSaveClick();
  }

  handleDetailSaveClick = () => {
    const saveBtn = document.querySelector('.k-window-content > .dialog-content > .detail-wrapper > #detail-toolbar .k-button.button-save');
    saveBtn.click();
  }

  handleSubmit = () => {
    if (buttonClicked === "confirm") {
      if (this.props.onConfirm) this.props.onConfirm(this.state);
      this.props.onClose();
    }
    else if (buttonClicked === "middle") {
      if (this.props.onMiddleClick) this.props.onMiddleClick(this.state);
    }
  }

  handleComponentFactory = (primaryField, field, value, onChange, obj) => {
    return this.props.componentFactory(primaryField, field, value, onChange, { ...obj, dialogObj: this.getObj() })
  }

  render() {
    const { data, detailData, isDetailLoading, isDetailDisabled }
      = (this.state.primaryField !== this.props.primaryField ? DEFAULT_STATE : (this.state[this.props.primaryField] || DEFAULT_STATE));
    const { detailSchema, fullscreen } = this.state;
    return (
      <Dialog
        ref={this.props.ref}
        title={this.props.title}
        isOpen={this.props.isOpen}
        onClose={this.props.onClose}
        onConfirm={this.handleConfirm}
        confirmDisabled={this.props.confirmDisabled}
        className={this.props.className}
        confirmText={this.props.confirmText}
        cancelText={this.props.cancelText}
        fullscreen={fullscreen}
        width={this.props.width}
        onMiddleClick={this.handleMiddle}
        middleText={this.props.middleText}
        level={this.props.level}
        disableConfirmOnEnter={this.props.disableConfirmOnEnter}
      >
        <Detail
          onSubmit={this.handleSubmit}
          detailData={detailData}
          onChangeField={this.changeField}
          allData={data}
          isDetailLoading={isDetailLoading}
          onGet={this.get}
          onCreate={this.create}
          onUpdate={this.update}
          getList={this.getList}
          primaryField={this.props.primaryField}
          schema={detailSchema}
          disabled={/*!!(flags.DETAIL & this.state.akc.disabled) ||*/isDetailDisabled}
          ui={this.state.ui}
          args={this.state.args}
          pages={this.state.pages}
          componentFactory={this.handleComponentFactory}
          {...this.state}
        />
      </Dialog>
    );
  }
}

DialogComponent.propTypes = {
  primaryField: PropTypes.string.isRequired,
  onMiddleClick: PropTypes.func,
  level: PropTypes.number,
  componentFactory: PropTypes.func,
  reducer: PropTypes.func,
  filterFactory: PropTypes.func,
  fullscreen: PropTypes.bool,
  confirmText: PropTypes.string,
  middleText: PropTypes.string,
  cancelText: PropTypes.string,
  db: PropTypes.string,
}

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
  getListSuccess: res => dispatch({ type: 'GET_LIST_SUCCESS', res }),
  getListFailure: error => dispatch({ type: 'GET_LIST_FAILURE', error }),
  getDetailSuccess: res => dispatch({ type: 'GET_SUCCESS', res }),
  getDetailFailure: error => dispatch({ type: 'GET_FAILURE', error }),
  createSuccess: res => dispatch({ type: 'CREATE_SUCCESS', res }),
  createFailure: error => dispatch({ type: 'CREATE_FAILURE', error }),
  updateSuccess: res => dispatch({ type: 'UPDATE_SUCCESS', res }),
  updateFailure: error => dispatch({ type: 'UPDATE_FAILURE', error }),
  deleteSuccess: () => dispatch({ type: 'DELETE_SUCCESS' }),
  deleteFailure: error => dispatch({ type: 'DELETE_FAILURE', error }),

  showMsg: (msg, msgType = 'ok', isDialog = false, title) => dispatch(showMsg(msg, msgType, isDialog, title))
})

export default withMeta(connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true }
)(DialogComponent));